export const DEFAULT_GAME_LIST_LIMIT = 16;
export const PROVIDER_GAMES_FETCH_LIMIT = 200;
